<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Project: MISA InvoiceBots
	Author: MISA JSC
	Author URL: http://www.misa.com.vn
========================================================================================== -->
<template>
	<div id="app">
		<div id="misa-notif-top-slot"></div>
		<router-view />
		<div id="message-box"></div>
		<ms-message-notification></ms-message-notification>
	</div>
</template>

<script>
import msMessageNotification from '@/components/msMessageNotification/msMessageNotification.vue';
export default {
	watch: {},
	components: {
		msMessageNotification,
	},
	computed: {},
	async created() {},
	mounted() {
		const me = this;
		var cfg = window.__env && window.__env.misaNotificationV2;
		if (!cfg || !cfg.isUsingNotifyV2) {
			me.setIFrameMisaNotify();
		}
		me.setGA4Element();
		me.setGTMElement();
	},
	// Phương thức
	methods: {
		/**
		 * nhúng iframe của Misa Notify
		 * @author dqduy 04.03.2024
		 */
		setIFrameMisaNotify() {
			try {
				let metaTag = document.createElement('meta');
				//Gán các thuộc tính của thẻ meta
				metaTag.setAttribute('name', 'misa-notify');
				metaTag.setAttribute(
					'integrationurl',
					window.__env.misaNotifyConfig.integrationURL
				);
				metaTag.setAttribute('appcode', window.__env.misaNotifyConfig.appCode);
				metaTag.setAttribute(
					'headercontainer',
					'#misa_notify_header_container'
				);
				// Thêm thẻ meta vào thẻ head
				document.head.appendChild(metaTag);

				//Tạo một thẻ script mới
				let script = document.createElement('script');
				script.src = window.__env.misaNotifyConfig.cdn;
				script.async = true; // Gán thuộc tính async cho thẻ script
				//Thêm thẻ script vào thẻ head
				document.head.appendChild(script);
			} catch (e) {
				console.log(e);
			}
		},
		/**
		 * add thêm thông tin GA4 cho ứng dụng
		 */
		setGA4Element() {
			try {
				var config = window.__env.ga4Config;
				if (!config.enable) return;

				let scriptTag = document.createElement('script');
				scriptTag.setAttribute('async', 'true');
				scriptTag.setAttribute('src', config.url);
				document.head.appendChild(scriptTag);

				let scriptActionTag = document.createElement('script');
				scriptActionTag.innerHTML =
					`
					window.dataLayer = window.dataLayer || [];
					function gtag(){dataLayer.push(arguments);}
					gtag('js', new Date());
					gtag('config', '` +
					config.token +
					`');
            	`;
				document.head.appendChild(scriptActionTag);
			} catch (e) {
				console.log(e);
			}
		},
		/**
		 * add thêm thông tin GTM cho ứng dụng
		 */
		setGTMElement() {
			try {
				var config = window.__env.gtmConfig;
				if (!config.enable) return;

				//Thêm ở headers
				let scriptActionTag = document.createElement('script');
				scriptActionTag.innerHTML =
					`
					(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
					new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
					j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
					'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
					})(window,document,'script','dataLayer','` +
					config.token +
					`');
            	`;
				document.head.appendChild(scriptActionTag);

				//Thêm ở body
				var noscript = document.createElement('noscript');
				noscript.innerHTML =
					`<iframe src="https://www.googletagmanager.com/ns.html?id=` +
					config.token +
					`" height="0" width="0" 
					style="display:none;visibility:hidden"></iframe>`;
				document.body.insertBefore(noscript, document.body.firstChild);
			} catch (e) {
				console.log(e);
			}
		},
	},
};
</script>

<style lang='scss'>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/common/app.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/common/app.scss';
}
</style>